import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Icons } from '@techsoftware/happay-widgets';
import DialogContentText from '@material-ui/core/DialogContentText';

export const CustomCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#1c8c51',
    },
    '&&:hover': {
      backgroundColor: '#f2f2f2',
    },
  },
  checked: {},
})(Checkbox);

export const CustomRadioButton = withStyles({
  root: {
    color: '#808080',
    '&$checked': {
      color: '#1c8c51',
    },
    '&&:hover': {
      backgroundColor: '#f2f2f2',
    },
  },
  checked: {},
})(Radio);

export const CustomTitle = withStyles({
  root: {
    '& h2': {
      fontFamily: 'Poppins',
      fontSize: '20px',
      color: '#0b1322',
      fontWeight: '600',
    },
    padding: '0px',
    width: '100%',
  },
})(DialogTitle);

export const CustomContent = withStyles({
  root: {
    padding: '10px 30px',
  },
})(DialogContent);

export const CustomAction = withStyles({
  root: {
    padding: '0 30px 30px',
  },
})(DialogActions);

export const ContentText = withStyles({
  root: {
    fontFamily: 'Poppins',
    margin: '0px',
  },
})(DialogContentText);

export const CustomDialog = props => {
  const onClose = () => {
    props.onClose();
  };

  const tempProps = { ...props };
  tempProps.title = null;
  tempProps.actions = null;

  return (
    <Dialog {...tempProps}>
      <Grid
        container
        className={`padding-t-30 padding-l-30 padding-r-30 ${
          props.title ? 'margin-b-10' : ''
        }`}
        xs={12}
      >
        <CustomTitle id="scroll-dialog-title">
          <Grid
            container
            justify="space-between"
            alignItems="center"
            direction="row"
            xs={12}
          >
            {props.title}
            {props.crossIcon && (
              <div title="close" className="float-left">
                <Icons interactive type="cross" onClick={onClose} />
              </div>
            )}
          </Grid>
        </CustomTitle>
      </Grid>
      <CustomContent dividers={props.dividers}>
        <ContentText id="scroll-dialog-description">
          {props.children}
        </ContentText>
      </CustomContent>
      <CustomAction className={props.actions ? 'margin-t-20' : ''}>
        {props.actions}
      </CustomAction>
    </Dialog>
  );
};

CustomDialog.propTypes = {
  open: PropTypes.bool,
  crossIcon: PropTypes.bool,
  children: PropTypes.any,
  onClose: PropTypes.func,
  title: PropTypes.any,
  actions: PropTypes.any,
  dividers: PropTypes.bool,
};
